import {darken} from "polished";
import React from "react";
import styled from "styled-components";
import ButtonBase from "../button/ButtonBase";
import ArrowLeftFillIcon from "../icons/ArrowLeftFillIcon/ArrowLeftFillIcon";
import ArrowRightFillIcon from "../icons/ArrowRightFillIcon/ArrowRightFillIcon";

interface NavigationProps {
    isFirst: boolean;
    isLast: boolean;
    children?: any;
    onClick?: (e: any) => void;
    onClickLeft?: (e: any) => void;
    onClickRight?: (e: any) => void;
    name?: string;
    prevRef?: React.Ref<HTMLButtonElement>;
    nextRef?: React.Ref<HTMLButtonElement>;
    prevClassName?: string;
    nextClassName?: string;
    sx?: object | undefined;
}

export const SwiperNavigation: React.FC<NavigationProps> = (
    {
        isFirst,
        isLast,
        children,
        onClick,
        onClickLeft,
        onClickRight,
        prevRef,
        nextRef,
        prevClassName,
        nextClassName,
        ...rest
    }
) => {
    return (
        <NavigationBox onClick={onClick} {...rest}>
            <NavigationRoot
                ref={prevRef}
                onClick={onClickLeft}
                className={prevClassName}
                sx={{visibility: isFirst ? "hidden" : "visible"}}
            >
                <ArrowLeftFillIcon/>
            </NavigationRoot>

            <NavigationRoot
                ref={nextRef}
                onClick={onClickRight}
                className={nextClassName}
                sx={{visibility: isLast ? "hidden" : "visible"}}
            >
                <ArrowRightFillIcon width="24px" height="24px"/>
            </NavigationRoot>
        </NavigationBox>
    );
};

const NavigationBox = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  padding: 0 1.5rem;
`;
const NavigationRoot = styled(ButtonBase)`
  position: relative;
  width: 48px;
  height: 48px;
  background: ${(props: any) => props.theme.palette.primitives.white};
  border-radius: 48px;
  z-index: 1500;

  &:active {
    background: ${darken(0.1, "#A5A5A5")};
  }

  &:active path {
    fill: ${darken(0.1, "#FFFFFF")};
  }
`;
